import React from 'react';

export default function CoherenceMeter({ level = 0, showLabel = true }) {
  const clampedLevel = Math.max(0, Math.min(1, level));
  const percentage = Math.round(clampedLevel * 100);
  
  const getColor = () => {
    if (clampedLevel < 0.3) return '#4a6fa5';
    if (clampedLevel < 0.6) return '#2a9d8f';
    if (clampedLevel < 0.8) return '#8b7355';
    return '#b76e79';
  };
  
  const color = getColor();
  
  return (
    <div className="flex flex-col items-center gap-1">
      {showLabel && (
        <span className="text-xs text-starlight/50">Coherence</span>
      )}
      
      <div className="flex items-end gap-1 h-6">
        {[...Array(5)].map((_, i) => {
          const barLevel = clampedLevel > (i * 0.2) ? 
            Math.min(1, (clampedLevel - i * 0.2) * 5) : 0.2;
          
          return (
            <div
              key={`bar-${i}`}
              className="w-1 rounded-full transition-all duration-500 ease-out"
              style={{ 
                backgroundColor: color,
                height: `${barLevel * 100}%`,
                opacity: barLevel
              }}
            />
          );
        })}
      </div>
      
      <span 
        className="text-xs font-mono coherence-fade"
        style={{ color }}
      >
        {percentage}%
      </span>
    </div>
  );
}
